import { createLazyOrchestrator } from 'owa-bundling';
import { getSearchState } from 'owa-calendar-search-view-store';
import { lazyIsSearchBoxEmpty } from 'owa-search';
import { lazyEndSearchSession, searchBoxBlurred } from 'owa-search-actions';
import { SearchScenarioId, getScenarioStore } from 'owa-search-store';

export const searchBoxBlurredOrchestrator = createLazyOrchestrator(
    searchBoxBlurred,
    'CLONE_CALENDAR_SEARCH_BOX_BLURRED',
    async actionMessage => {
        if (actionMessage.scenarioId != SearchScenarioId.Calendar) {
            return;
        }
        const isSearchBoxEmpty = await lazyIsSearchBoxEmpty.import();

        /**
         * Exit search session if:
         * - User is in a search session AND
         * - Search box is empty AND
         * - Results aren't being shown
         */
        if (
            getScenarioStore(SearchScenarioId.Calendar).searchSessionGuid &&
            isSearchBoxEmpty(SearchScenarioId.Calendar) &&
            !getSearchState()
        ) {
            // invoke endSearchSession common action
            const endSearchSession = await lazyEndSearchSession.import();
            endSearchSession(SearchScenarioId.Calendar);
        }
    }
);
